import { defineStore } from 'pinia';

// Types
import type { UserData } from '@white-label-types/stores';

type VehicleLookUpState = { [key: string]: boolean };

// Payment method identifier used by the payment widget for Apple Pay
const APPLE_PAY_METHOD = 'applePay';

export interface PaymentFormState {
  formData: null | UserData;
  timestamp: null | string;
  vehicleLookUp: null | VehicleLookUpState;
  paymentMethod: string;
}

export type StoreFormDataPayload = {
  formData: UserData,
  timestamp?: string
}

/**
 * Payment form store definition
 *
 * @returns {StoreDefinition}
 */
export const usePaymentFormStore = defineStore({
  id: 'paymentForm',

  actions: {
    commitStoreFormData(payload: StoreFormDataPayload) {
      // @ts-expect-error - types are correct but package is out of date
      this.formData = { ...payload.formData };
      // @ts-expect-error - types are correct but package is out of date
      if (payload.timestamp) this.timestamp = payload.timestamp;
    },

    commitStoreVehicleLookUpState(payload: VehicleLookUpState) {
      // @ts-expect-error - types are correct but package is out of date
      this.vehicleLookUp = { ...payload };
    },

    commitClearFormData() {
      // @ts-expect-error - types are correct but package is out of date
      this.formData = null;
      // @ts-expect-error - types are correct but package is out of date
      this.timestamp = null;
      // @ts-expect-error - types are correct but package is out of date
      this.vehicleLookUp = null;
      // @ts-expect-error - types are correct but package is out of date
      this.paymentMethod = '';
    },

    /**
     * Stores the selected payment method for flow control decisions.
     */
    commitPaymentMethod(paymentMethod: string) {
      // @ts-expect-error - types are correct but package is out of date
      this.paymentMethod = paymentMethod;
    },
  },

  getters: {
    readPaymentFormData: (state) => state.formData,
    readVehicleLookUpState: (state) => state.vehicleLookUp,
    isApplePay: (state) => state.paymentMethod === APPLE_PAY_METHOD,
  },

  state() {
    return {
      formData: null,
      vehicleLookUp: null,
      timestamp: null,
      paymentMethod: '',
    }
  },

  // @ts-expect-error - Persist plugin is not typed
  persist: {
    storage: process.client ? sessionStorage : undefined,
  },
});
